
import React, { useState, useEffect } from "react";
import { cn } from "@/lib/utils";
import Logo from "./navbar/Logo";
import NavLinks from "./navbar/NavLinks";
import { AuthButtons } from "./navbar/AuthButtons";
import MobileMenuButton from "./navbar/MobileMenuButton";
import MobileMenu from "./navbar/MobileMenu";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [locationDropdownOpen, setLocationDropdownOpen] = useState(false);
  const [resourcesDropdownOpen, setResourcesDropdownOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <nav
        className={cn(
          "fixed top-0 w-full z-50 transition-all duration-300 border-b border-gray-100",
          scrolled
            ? "bg-white py-3 shadow-sm bg-white/95"
            : "bg-white py-4"
        )}
      >
        <div className="container flex items-center justify-between">
          <div className="flex items-center">
            <Logo />

            {/* Desktop Navigation */}
            <div className="hidden lg:block ml-8">
              <NavLinks 
                locationDropdownOpen={locationDropdownOpen}
                setLocationDropdownOpen={setLocationDropdownOpen}
                resourcesDropdownOpen={resourcesDropdownOpen}
                setResourcesDropdownOpen={setResourcesDropdownOpen}
              />
            </div>
          </div>

          {/* Auth buttons and Waitlist CTA - Desktop */}
          <div className="hidden lg:flex items-center space-x-4">
            <AuthButtons />
          </div>

          {/* Mobile menu button */}
          <MobileMenuButton isOpen={isOpen} onClick={toggleMenu} />
        </div>

        {/* Dropdown overlay effect - shown when any dropdown is open */}
        {(locationDropdownOpen || resourcesDropdownOpen) && (
          <div 
            className="fixed inset-0 bg-black/5 -z-10" 
            onClick={() => {
              setLocationDropdownOpen(false);
              setResourcesDropdownOpen(false);
            }}
          />
        )}
      </nav>

      {/* Mobile menu */}
      <MobileMenu isOpen={isOpen} onClose={() => setIsOpen(false)} />
      
      <div className={cn("h-16 w-full", scrolled ? "h-[72px]" : "h-[80px]")}></div>
    </>
  );
}
